// Sala de servidores: piso de metal perfurado, duas fileiras de racks com corredores entre
// elas (a equipe fica no corredor, de frente para o rack) e um posto de NOC com três mesas no
// fundo. Racks são os itens com LED animado.

import type { Placement, RoomMap, Spot } from '../../core/world.js';

// Racks nas colunas ímpares, em duas fileiras. Cada rack tem o ponto de manutenção logo abaixo
// (no corredor), virado para cima.
const RACK_COLS = [1, 3, 5, 7, 9, 11, 13];
const racks: Placement[] = [1, 3].flatMap((y) => RACK_COLS.map((x) => ({ item: 'rack-servidor', x, y })));

// Posto de NOC: uma cadeira em frente a cada mesa, virada para ela.
const NOC_COLS = [2, 6, 10];
const noc: Spot[] = NOC_COLS.map((x) => ({ id: `servidores:noc-${x}`, x, y: 5, facing: 'down', kind: 'chair', use: 'work' }));

export const SERVIDORES: RoomMap = {
  id: 'servidores',
  kind: 'servers',
  name: 'Servidores',
  // s = piso de servidor (placa de metal)
  floor: Array.from({ length: 9 }, () => 'ssssssssssssssss'),
  legend: { s: 'piso-servidor' },
  items: [
    // parede norte: ar-condicionado, quadro, relógio e placa de saída
    { item: 'ar-condicionado', x: 2, y: 0 },
    { item: 'quadro-avisos', x: 6, y: 0 },
    { item: 'relogio', x: 9, y: 0 },
    { item: 'ar-condicionado', x: 12, y: 0 },
    { item: 'placa-saida', x: 15, y: 0 },
    ...racks,
    // posto de NOC: três mesas, cadeiras e no-break no canto
    { item: 'mesa-noc', x: 2, y: 6 },
    { item: 'mesa-noc', x: 6, y: 6 },
    { item: 'mesa-noc', x: 10, y: 6 },
    { item: 'cadeira-escritorio', x: 2, y: 5 },
    { item: 'cadeira-escritorio', x: 6, y: 5 },
    { item: 'cadeira-escritorio', x: 10, y: 5 },
    { item: 'no-break', x: 1, y: 7 },
    { item: 'no-break', x: 13, y: 7 },
    { item: 'caixas-papelao', x: 14, y: 7 },
    { item: 'lixeira', x: 0, y: 8 },
  ],
  doors: [{ x: 7, y: 8 }],
  spots: noc,
};
